/* global google */
import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import messages from './Messages';

class GoogleMaps extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};

    this.map = React.createRef();
  }
  componentDidMount() {
    if (this.props.lat === null) {
      axios.get('https://freegeoip.app/json/').then((res) => {
        this.setState({
          lat: res.data.latitude,
          lng: res.data.longitude,
        });
        this.loadJS(
          'https://maps.googleapis.com/maps/api/js?key=AIzaSyCZjAK1Oo5-UroLIoOhHTMlOXIMRClxDg0&callback=initMap'
        );
        window.initMap = this.initMap.bind(this);
      });
    } else {
      this.setState({
        lat: this.props.lat,
        lng: this.props.lng,
      });
      this.loadJS(
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyCZjAK1Oo5-UroLIoOhHTMlOXIMRClxDg0&callback=initMap'
      );
      window.initMap = this.initMap.bind(this);
    }
  }

  UNSAFE_componentWillUpdate(newProps, newState) {
    if (!newProps.marker) {
      this.marker.setMap(null);
    }
  }

  componentWillUnmount() {
    window.google = {};
    const scripts = document.querySelectorAll(
      // eslint-disable-next-line quotes
      "script[src*='maps.googleapis.com/']"
    );
    for (let i = 0; i < scripts.length; i++) {
      scripts[i].parentNode.removeChild(scripts[i]);
    }
  }

  initMap() {
    const { lat, lng, marker, handleChangeLatLng } = this.props;
    this.map = new google.maps.Map(this.map.current, {
      center: { lat: this.state.lat, lng: this.state.lng },
      zoom: 10,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });
    if (marker) {
      this.marker = new google.maps.Marker({
        position: { lat, lng },
        map: this.map,
        draggable: true,
        animation: google.maps.Animation.DROP,
        title: messages.markerMessage,
      });
      this.marker.addListener('dragend', () => {
        handleChangeLatLng(
          this.marker.getPosition().lat(),
          this.marker.getPosition().lng()
        );
      });
      this.map.addListener('click', (event) => {
        this.marker.setMap(this.map);
        this.marker.setPosition(event.latLng);
        handleChangeLatLng(
          this.marker.getPosition().lat(),
          this.marker.getPosition().lng()
        );
      });
      this.locationButton(this.map, this.marker);
    }
  }

  loadJS(src) {
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    document.head.appendChild(s);
  }

  locationButton(map, marker) {
    const controlDiv = document.createElement('div');

    const firstChild = document.createElement('button');
    firstChild.style.backgroundColor = 'var(--exact-white)';
    firstChild.style.border = 'none';
    firstChild.style.outline = 'none';
    firstChild.style.width = '28px';
    firstChild.style.height = '28px';
    firstChild.style.borderRadius = '2px';
    firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
    firstChild.style.cursor = 'pointer';
    firstChild.style.marginRight = '10px';
    firstChild.style.padding = '0';
    firstChild.title = 'Your Location';
    controlDiv.appendChild(firstChild);

    const secondChild = document.createElement('div');
    secondChild.style.margin = '5px';
    secondChild.style.width = '18px';
    secondChild.style.height = '18px';
    secondChild.style.backgroundImage =
      'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-2x.png)';
    secondChild.style.backgroundSize = '180px 18px';
    secondChild.style.backgroundPosition = '0 0';
    secondChild.style.backgroundRepeat = 'no-repeat';
    firstChild.appendChild(secondChild);

    google.maps.event.addListener(map, 'center_changed', function () {
      secondChild.style['background-position'] = '0 0';
    });

    firstChild.addEventListener('click', function (event) {
      event.preventDefault();
      let imgX = 0;
      const animationInterval = setInterval(function () {
        imgX = -imgX - 18;
        secondChild.style['background-position'] = imgX + 'px 0';
      }, 500);

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          const latlng = new google.maps.LatLng(
            position.coords.latitude,
            position.coords.longitude
          );
          map.setCenter(latlng);
          clearInterval(animationInterval);
          secondChild.style['background-position'] = '-144px 0';
        });
      } else {
        clearInterval(animationInterval);
        secondChild.style['background-position'] = '0 0';
      }
    });

    controlDiv.index = 1;
    map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
  }

  render() {
    return (
      <div
        ref={this.map}
        style={{ height: this.props.height, width: this.props.width }}
      />
    );
  }
}

GoogleMaps.propTypes = {
  lat: PropTypes.number,
  lng: PropTypes.number,
  width: PropTypes.string,
  height: PropTypes.string,
  marker: PropTypes.bool,
  handleChangeLatLng: PropTypes.func,
};

GoogleMaps.defaultProps = {
  height: '300px',
  width: '600px',
};

export default GoogleMaps;
